export const KEYS = {
  TOP_APP_BAR_HEIGHT_MOBILE: '66px',
  MAIN_COMPONENT_TRANSITION_EASING: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  MAIN_COMPONENT_TRANSITION_DURATION: '0.3s',
};
